import React from "react";
import { css } from "emotion";

import styleConfig from "styles/styleConfig";

const { colors, margin, padding, gradient, borderRadius, fontSize, boxShadow, screens, transition } = styleConfig;

const productStyle = css`
  position: relative;
  width: calc(25% - 2rem);
  margin: 0 ${margin[4]} ${margin[4]} ${margin[4]};
  padding: ${padding[4]};
  border-radius: ${borderRadius.lg};
  transition: ${transition.default};
  box-shadow: ${boxShadow.sm};
  .header {
    position: relative;
    img.image {
      width: 100%;
    }
    .reduction {
      position: absolute;
      top: -${margin[6]};
      right: -${margin[6]};
      color: ${colors.white};
      background: ${gradient.secondary};
      padding: ${padding[2]} ${padding[4]};
      border-radius: ${borderRadius.md};
      font-size: 22px;
      font-weight: bold;
    }
  }
  .title {
    display: -webkit-box;
    height: 34px;
    margin: ${margin[2]} 0;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .unit {
    font-weight: bold;
    color: ${colors.gray[500]};
  }
  .price {
    display: flex;
    font-size: ${fontSize.lg};
    font-weight: 900;
  }
  .old-price {
    font-size: ${fontSize.xs};
    text-decoration: line-through;
  }
  &:hover {
    border: none;
    transform: scale(1.01) translateY(-5px);
    box-shadow: ${boxShadow.xl};
  }
  @media (max-width: ${screens.MOBILE_WIDTH}px) {
    width: calc(50% - 2rem);
  }
`;

interface ProductProps {
  title: string;
  price: number;
  image: string;
  oldPrice?: number;
  unit?: string;
}

const Product: React.FC<ProductProps> = props => {
  if (!props.image || !props.price || !props.title) {
    return null;
  }
  const price = props.price.toString().split(".");
  const reduction = props.oldPrice && Math.abs(props.price / props.oldPrice - 1) * 100;
  return (
    <div className={productStyle}>
      <div className="header">
        <img className="image" src={props.image} alt={props.title} />
        {reduction && <div className="reduction">-{reduction.toFixed(0)}%</div>}
      </div>
      <div className="title">{props.title}</div>
      {props.unit && <div className="unit">{props.unit}</div>}
      <div className="price">
        <div className="currency">€</div>
        <div className="big">{price[0]}.</div>
        <sup className="small">{price[1]}</sup>
      </div>
      {props.oldPrice && <div className="old-price">€{props.oldPrice}</div>}
    </div>
  );
};

export default Product;
